
export class GrantTypes {
    public static readonly CLIENTCREDENTIALS: string = "Client Credentials";
    public static readonly AUTHORIZATIONCODE: string = "Authorization Code";
    public static readonly RESOURCEOWNER: string = "Resource Owner Credentials";
    public static readonly TESTer: string = "Resource Owner Credentials";
}